@import '~less/bootstrap/legacy-mixins';

@import '~less/global-variables';
@import '~less/layout/typography';

/**
 * Forms
 */
textarea,
input[type='text'],
input[type='password'],
input[type='datetime'],
input[type='datetime-local'],
input[type='date'],
input[type='month'],
input[type='time'],
input[type='week'],
input[type='number'],
input[type='email'],
input[type='url'],
input[type='search'],
input[type='tel'],
input[type='color'] {
  // Focus state
  &:focus {
    border-color: lighten(@brand-primary, 50%);
    box-shadow: 0 0 3px lighten(@brand-primary, 50%);
  }

  // iOS tends to mess up form elements
  // @link http://stackoverflow.com/a/10757425/1984644
  -webkit-appearance: none;

  // Hide Internet Explorer "x" from inputs
  &::-ms-clear {
    display: none;
  }
}

// The application provides its own reveal-password button
input[type='password']::-ms-reveal {
  display: none;
}

label {
  color: @gray-light;
  .font-brand-regular();
}
.radio label,
.checkbox label {
  color: @text-color;
}
label + .radio,
label + .checkbox {
  margin-top: -5px;
}

// Form validation errors
.has-error .form-control,
.has-error .form-control:focus {
  border-color: @brand-danger;
  box-shadow: 0 0 3px lighten(@brand-danger, 50%);
}

.help-block {
  display: block;
  opacity: 1;
  padding: 5px 0;
  margin: 0;
  .font-brand-regular();
  color: @gray-light;
}

// Input without any borders and other visual cues
.input-plain {
  border-color: transparent;
  background: transparent;
  color: @text-color;
  &,
  &:focus,
  &:active {
    box-shadow: none;
    outline: none;
  }
}

// A special group to build mobile friendly number stepper controllers
// [-][number][+]
.input-group-stepper {
  max-width: 200px;
  @media (max-width: @screen-xs) {
    margin: 0 auto;
  }
  .btn {
    &,
    &:focus {
      outline: none;
    }
  }
  input {
    margin: 0 1px;
    font-size: 28px;
    line-height: 28px;
    &,
    &:hover {
      -moz-appearance: textfield;
      -webkit-appearance: textfield;
    }
    // Leave number input clickable but hide special appearance
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }
    &:focus {
      box-shadow: none;
      border-color: transparent;
      color: @brand-primary;
    }
  }
}
